"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormattedMethod = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _IntlTelInput = require("../components/Input/IntlTelInput");

/*
 * Hook to format international  telephone number
 *
 * @params {string} input - the number to format
 * @params {boolean} enableFormat - the tigger that whether the hook should format the input
 */
var useFormattedMethod = function useFormattedMethod(input) {
  var enableFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState = (0, _react.useState)(input),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      output = _useState2[0],
      setOutput = _useState2[1];

  var shouldFormat = enableFormat && input;
  (0, _react.useEffect)(function () {
    if (shouldFormat) {
      (0, _IntlTelInput.setupIntlTelUtils)().then(function (utils) {
        var formatted = utils.formatNumber(input, null, utils.numberFormat.NATIONAL);
        setOutput(formatted);
      });
    }
  }, [shouldFormat]);
  return shouldFormat ? output : input;
};

exports.useFormattedMethod = useFormattedMethod;
//# sourceMappingURL=recoveryMethod.js.map